export default __webpack_public_path__ + "static/media/yellow_plus.c279833d.svg";